import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { Modal } from "@/shared/ui/modal"
import { yupResolver } from "@hookform/resolvers/yup"
import { FieldError, SubmitHandler, useForm } from "react-hook-form"
import { FormInput } from "@/shared/ui/form-input"
import notify from "@/shared/lib/notify"
import { getErrorMessage } from "@/shared/consts/error-codes"
import { closeUpdateVacancyModal, fetchUpdateVacancy, selectCurrentVacancy, selectIsUpdateVacancyModalOpen, selectOnUpdate, updateVacancySchema } from "../../model"
import { useEffect } from "react"

interface UpdateVacancyFormValues {
    name: string,
    description: string,
    salary: string,
    preview: File
}

const initialState: UpdateVacancyFormValues = {
    name: "",
    description: "",
    salary: "",
    preview: null
}

export const UpdateVacancyModal = () => {
    const dispatch = useAppDispatch()
    const isOpen = useAppSelector(selectIsUpdateVacancyModalOpen)
    const onUpdate = useAppSelector(selectOnUpdate)
    const currentVacancy = useAppSelector(selectCurrentVacancy)

    useEffect(() => reset({
        name: currentVacancy.name,
        description: currentVacancy.salary,
        salary: currentVacancy.salary,
        preview: undefined
    }), [currentVacancy])

    const handleClose = () => {
        dispatch(closeUpdateVacancyModal())
    }

    const onSubmit: SubmitHandler<typeof initialState> = async (data) => {
        await new Promise((res, rej) => {
        dispatch(fetchUpdateVacancy({
            name: data.name,
            description: data.description,
            salary: data.salary,
            preview: data.preview
        }))
        .unwrap()
        .then(() => {
            notify.success('Вакансия успешно изменена')
            reset()
            onUpdate?.()
            handleClose()
            res('')
        })
        .catch((e) => {
            notify.error(getErrorMessage(e))
            rej()
        })
        })
    }   

    const {
        register,
        handleSubmit,
        formState: { errors, isSubmitting },
        reset
    } = useForm({
        defaultValues: initialState,
        resolver: yupResolver(updateVacancySchema)
    })

    return (
        <Modal
            isOpen={isOpen}
            title="Изменение вакансии"
            onRequestClose={handleClose}       
        >
            <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-3">
                <FormInput 
                    register={register} 
                    label={"Название"} 
                    id={"name"} 
                    error={errors['name']}
                    required={true}
                    placeholder="Введите название вакансии"               
                />
                <FormInput 
                    register={register} 
                    label={"Описание"} 
                    id={"description"} 
                    error={errors['description']}
                    required={true}
                    placeholder="Введите описание вакансии"               
                />
                <FormInput 
                    register={register} 
                    label={"Зарплатная вилка"} 
                    id={"salary"} 
                    type="textarea"
                    rows={5}
                    error={errors['salary']}
                    required={true}
                    placeholder="Введите зарплатную вилку"               
                />
                <FormInput 
                    register={register} 
                    label={"Превью (опционально)"} 
                    id={"preview"} 
                    type="file"
                    error={errors['preview'] as FieldError}
                    required={false}
                    placeholder=""               
                />
                <div className="w-full flex gap-3">
                    <button onClick={handleClose} className="form_cancel_button">
                        Отменить
                    </button>
                    <button disabled={isSubmitting} className="form_handle_button" type="submit">
                        Сохранить
                    </button>
                </div>
            </form>
        </Modal>
    )
}